import { Link } from 'react-router-dom';
import styles from './Logo.module.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ size = 'medium', showText = true }) => {
  const sizeMap = {
    small: 40,
    medium: 60,
    large: 80,
  };

  const logoSize = sizeMap[size];

  return (
    <Link to="/" className={styles.logoLink} aria-label="Inicio">
      <svg
        className={styles.logo}
        width={logoSize}
        height={logoSize}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="50" cy="50" r="45" fill="#4caf50" opacity="0.1" />
        <circle cx="50" cy="50" r="40" fill="none" stroke="#2e7d32" strokeWidth="2" />

        {/* Stem */}
        <line x1="50" y1="70" x2="50" y2="40" stroke="#2e7d32" strokeWidth="3" />

        {/* Leaves */}
        <path
          d="M 50 50 Q 35 45 30 35"
          fill="none"
          stroke="#4caf50"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M 50 50 Q 65 45 70 35"
          fill="none"
          stroke="#4caf50"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M 50 60 Q 38 58 32 50"
          fill="none"
          stroke="#4caf50"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M 50 60 Q 62 58 68 50"
          fill="none"
          stroke="#4caf50"
          strokeWidth="2.5"
          strokeLinecap="round"
        />

        {/* DNA helix */}
        <g transform="translate(45, 30)">
          <ellipse cx="5" cy="0" rx="3" ry="1.5" fill="#2e7d32" />
          <ellipse cx="5" cy="5" rx="3" ry="1.5" fill="#66bb6a" />
          <ellipse cx="5" cy="10" rx="3" ry="1.5" fill="#2e7d32" />
          <line x1="5" y1="0" x2="5" y2="10" stroke="#1b5e20" strokeWidth="1" opacity="0.5" />
        </g>
      </svg>

      {showText && (
        <div className={styles.logoText}>
          <h1 className={styles.title}>Mejoramiento Genético Vegetal</h1>
          <p className={styles.subtitle}>Facultad de Ciencias Agropecuarias - UNC</p>
        </div>
      )}
    </Link>
  );
};
